


import { SvgIcon, SvgIconProps } from "@mui/material";

export const RecurringTicketsSidebarIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 19h-3a5 5 0 0 1-5-5V5M11 5h3a5 5 0 0 1 5 5v9"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.5 7.5 5 5 2.5 7.5M16 16l3 3 3-3"/></svg>
  </SvgIcon>
);
